function updateExternalLinks(root) {
  const links = root.matches?.('a[href]') ? [root] : [...root.querySelectorAll('a[href]')];
  for (const link of links) {
    let url;
    try { url = new URL(link.getAttribute('href'), location.href); } catch { continue; }
    if (!['http:', 'https:'].includes(url.protocol) || url.hostname === location.hostname) continue;
    link.target = '_blank';
    link.relList.add('noopener', 'noreferrer');
  }
}
updateExternalLinks(document);
new MutationObserver(records => {
  for (const record of records) {
    if (record.type === 'attributes') updateExternalLinks(record.target);
    for (const node of record.addedNodes) {
      if (node.nodeType === Node.ELEMENT_NODE) updateExternalLinks(node);
    }
  }
}).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['href']});
